let cacheSize = parseInt(localStorage.getItem('pageSize'));
const tableData = {
    sales_post:{
        data: [],
        selection: 'single',
        selected: [],
        count: 0,
        loading:false,
        isFullscreen:false,
        pagination: { rowsPerPage: cacheSize?cacheSize:30, rowsNumber: 3, page: 1, },
        tools: {
            show_toolbar: true,
        },
        columns: [
            {name: 'id', align: 'left', label: 'id', field: 'id', sortable: true},
            {name: 'change_type', align: 'left', label: '数据变更类型', field: 'change_type', sortable: true},
            {name: 'F_BillNO', align: 'left', label: '出库单编号', field: 'F_BillNO', sortable: true},
            {name: 'F_Date', align: 'left', label: '出库单日期', field: 'F_Date', sortable: true,format: (val) => `${val ? val : ''}`},
            {name: 'F_CustomerName', align: 'left', label: '客户名称', field: 'F_CustomerName', sortable: true},
            {name: 'F_CustomerTaxNO', align: 'left', label: '客户税号', field: 'F_CustomerTaxNO', sortable: true},
            {name: 'F_Province', align: 'left', label: '省份', field: 'F_Province', sortable: true},
            {name: 'F_City', align: 'left', label: '省份/直辖市/自治区', field: 'F_City', sortable: true},
            {name: 'F_Branch', align: 'left', label: '行业', field: 'F_Branch', sortable: true},
            {name: 'F_CustomerType', align: 'left', label: '客户类型', field: 'F_CustomerType', sortable: true},
            {name: 'F_EntryID', align: 'left', label: '销售出库单行号', field: 'F_EntryID', sortable: true},
            {name: 'F_MaterialNo', align: 'left', label: '订货号', field: 'F_MaterialNo', sortable: true},
            {name: 'F_Qty', align: 'left', label: '数量', field: 'F_Qty', sortable: true},
            {name: 'created_date', align: 'left', label: '上报日期', field: 'created_date', sortable: true},
            {name: 'pushed_time', align: 'left', label: '上报时间', field: 'pushed_time', sortable: true,format: (val) => `${val ? val : ''}`},
            {name: 'state', align: 'left', label: '上报状态', field: 'state', sortable: true},
            {name: 'message', align: 'left', label: '消息', field: 'message', sortable: true},
        ]
    }
}
const state = () => ({
    sales: Object.assign({}, tableData),
})
const getters = {
    getSalesPost: state => state.sales.sales_post,
}
const mutations ={
    setList(state, data) {
        state.sales.sales_post.pagination.rowsNumber = data.count
        state.sales.sales_post.data = data.data
        state.sales.sales_post.selected = [data.data[0]]
    },
    ['refreshTableHeight'](state, data) {
        state.sales.sales_post.maxHeight = (data -55) + 'px';
    },
    ['clearData'](state, data) {
        state.sales.sales_post.pagination.page = 1
        state.sales.sales_post.data = []
    }
}
const actions = {
    async ['fetch-list']({ state, dispatch, rootState }, payload) {
        if (state.sales.sales_post.loading == true) return
        let msg = { command: "outbound__list", message: payload, to: "client" }
        dispatch('channel/socket_send', msg, { root: true })
        state.sales.sales_post.loading = true
    },
    async ['return_sales__list']({ state, commit }, payload) {
        state.sales.sales_post.loading = false;
        if (payload.success) {
            commit('setList', payload.data)
        }
    },
    async['export_excel']({ state, dispatch, rootState }, payload) {
        state.sales.sales_post.loading = true
        let msg = { command: "outbound__export", message: payload, to: "client" }
        dispatch('channel/socket_send', msg, { root: true })
        dispatch('response/info-tip', { message: '正在导出' }, { root: true })
    },
    async['return_sales__export']({ state, dispatch, rootState }, payload) {
        if (payload.success) {
            window.open(payload.data, '_blank')
            dispatch('response/success-tip', { message: '导出成功' }, { root: true })
        }
        state.sales.sales_post.loading = false;
    },
}
export default {
    namespaced: true,
    state,
    actions,
    mutations,
    getters
}
